/**
 * Preserved demo showcase examples — GENERATED by scripts/build-demo-examples.mjs.
 * Do not edit by hand; edit scripts/showcase-sources.json (or the architecture in
 * the build script) and re-run the script.
 */
import type { DiagramData } from '../../lib'
import architectureData from './data/architecture.json'
import erdData from './data/erd.json'
import classData from './data/class.json'
import sequenceData from './data/sequence.json'
import stateData from './data/state.json'
import c4Data from './data/c4.json'
import ganttData from './data/gantt.json'
import architectureThumb from './thumbnails/architecture.png'
import erdThumb from './thumbnails/erd.png'
import classThumb from './thumbnails/class.png'
import sequenceThumb from './thumbnails/sequence.png'
import stateThumb from './thumbnails/state.png'
import c4Thumb from './thumbnails/c4.png'
import ganttThumb from './thumbnails/gantt.png'

export interface DemoExample {
  id: string
  title: string
  description: string
  diagramType: string
  data: DiagramData
  thumbnail: string
}

export const DEMO_EXAMPLES: DemoExample[] = [
  { id: 'architecture', title: "ShopSphere — System Architecture", description: "Layered microservice architecture: clients → edge → services → data, with external integrations.", diagramType: 'architecture', data: architectureData as unknown as DiagramData, thumbnail: architectureThumb },
  { id: 'erd', title: "ShopSphere — Commerce Data Model (ERD)", description: "Entity-relationship schema for ShopSphere: users place orders of catalog products, settled by Stripe payments and fulfilled via shipments.", diagramType: 'erd', data: erdData as unknown as DiagramData, thumbnail: erdThumb },
  { id: 'class', title: "ShopSphere — Domain Class Model", description: "UML class model of ShopSphere's core e-commerce domain: users and admins, carts, products, orders with line items, and Stripe payments.", diagramType: 'class', data: classData as unknown as DiagramData, thumbnail: classThumb },
  { id: 'sequence', title: "ShopSphere — Checkout & Payment Flow", description: "A customer's checkout request flows through the web app and Orders API, which persists the order, charges Stripe, and branches on approval or decline.", diagramType: 'sequence', data: sequenceData as unknown as DiagramData, thumbnail: sequenceThumb },
  { id: 'state', title: "ShopSphere — Order Lifecycle State Machine", description: "The states a ShopSphere order moves through from checkout to delivery, including cancellation, returns, and refunds.", diagramType: 'state', data: stateData as unknown as DiagramData, thumbnail: stateThumb },
  { id: 'c4', title: "ShopSphere — System Context (C4)", description: "C4 context for the ShopSphere e-commerce platform, showing customers and admins interacting with the system and its four external dependencies (payments, email, search, analytics).", diagramType: 'c4', data: c4Data as unknown as DiagramData, thumbnail: c4Thumb },
  { id: 'gantt', title: "ShopSphere — Launch Plan", description: "A 10-week launch roadmap from market research through public launch, with parallel build tracks and a go-live milestone.", diagramType: 'gantt', data: ganttData as unknown as DiagramData, thumbnail: ganttThumb },
]
